import React from 'react';
import {SvgIcon} from '@mui/material';
import type {IconProps} from './types';

export const PlaceholderIcon: React.FC<IconProps> = ({sx: _sx, ...props}) => {
  return (
    <SvgIcon
      aria-hidden
      {...props}
      viewBox="0 0 24 24"
      sx={[{visibility: 'hidden'}]}>
      <path d="M12 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM13 16v-5h-2v5h2Z" />
    </SvgIcon>
  );
};
